import { render, staticRenderFns } from "./AccountEmailTemplates.vue?vue&type=template&id=08054b2d"
import script from "./AccountEmailTemplates.vue?vue&type=script&lang=js"
export * from "./AccountEmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./AccountEmailTemplates.vue?vue&type=style&index=0&id=08054b2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports